import axios from 'axios';

import { releaseVersion } from '~sf/components/app/AppVersion';

type VersionResponse = {
  version: string;
};

async function checkVersionIsLatest(): Promise<boolean> {
  const latestVersion = await getLatestVersion();

  if (latestVersion === '0') {
    // we don't care if it fails to load the version, it's just a nice to have
    return true;
  }

  return latestVersion === releaseVersion;
}

async function getLatestVersion() {
  const res = await axios
    .get<VersionResponse>(`/version.json?${new Date().getTime()}`) // adding a random query string to force a refresh
    .catch(() => ({ data: { version: '0' } }));

  return res.data.version;
}

export default checkVersionIsLatest;
